module.exports = __webpack_public_path__ + "static/media/AkC4.fafeee60.png";